import { render, staticRenderFns } from "./DuplicateSection.vue?vue&type=template&id=d53bbf12&scoped=true&"
import script from "./DuplicateSection.vue?vue&type=script&lang=js&"
export * from "./DuplicateSection.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateSection.vue?vue&type=style&index=0&id=d53bbf12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53bbf12",
  null
  
)

export default component.exports